module.exports = __webpack_public_path__ + "img/icon-pen.3b9c77dc.svg";